// src/contexts/PWAProvider.tsx
// Provides usePWA() context to the entire app tree.
import React from 'react';
import { usePWAInternal } from '../hooks/usePWA';
import { PWAContext } from './pwa-hooks';

export const PWAProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const pwa = usePWAInternal();
    return <PWAContext.Provider value={pwa}>{children}</PWAContext.Provider>;
};
